export default {
  FULL_CAPTURED: 'fully_captured',
  ON_HOLD: 'on_hold',
  SUCCESS: 'success',
  APPROVED: 'approved',
  AUTHORISED: 'authorised',
  DECLINED: 'declined',
}
